import { useTranslation } from "react-i18next";
import { Gift } from "lucide-react";
import { RewardsPanel } from "@/components/RewardsPanel";

export default function Rewards() {
  const { t } = useTranslation();
  return (
    <div className="section-sand min-h-[70vh] py-10 px-4">
      <div className="max-w-5xl mx-auto">
        <h1 className="font-heading font-extrabold text-3xl text-ink flex items-center gap-2 mb-6" data-testid="rewards-page-title">
          <Gift className="w-7 h-7 text-canard" /> {t("rewards.title")}
        </h1>
        <RewardsPanel />
      </div>
    </div>
  );
}
